import { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import methods from '../../services/utility';
import apiMethod from '../../services/api-service';

const WaiterHeader = ({ setCollapsed }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState({
    userId: 0,
    userName: '',
    firstName: '',
    lastName: '',
    avatar: '',
    roleName: '',
    branchTitle: ''
  });
  const bindUserInfo = async () => {
    const apiRes = await apiMethod.getLoginedWaiterInfo();
    if (apiRes.status === 401 && methods.checkUserLogin()) {
      navigate('/DeliveryPanel')
    }
    if (!methods.showApiErrors(apiRes))
      return false;

    userData.userId = apiRes.data.userId;
    userData.userName = apiRes.data.userName;
    userData.firstName = apiRes.data.firstName;
    userData.lastName = apiRes.data.lastName;
    userData.avatar = apiRes.data.avatar;
    userData.branchTitle = apiRes.data.branchTitle;
    setUserData({ ...userData });
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await bindUserInfo();
      setLoading(false);
    }
    fetchData();
  }, []);

  const NavbarToggleSidebar = () => {
    setCollapsed(false)
  };

  const renderHeader = () => {
    return (
      <header className="navbar">
        <div className="date d-lg-block">
          {methods.currentDate()}
          <span className='mx-5 text-dark fs-6'><strong>{userData.branchTitle}</strong></span>
        </div>
        <div className="dropdown">
          <button className="btn btn-sm dropdown-toggle d-flex align-items-center"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {userData &&
              <div className="user-description">
                <img src={methods.normalImage(userData.avatar, 'avatar')} alt='avatar' className='user-image' />
                <div>
                  <span>{userData.firstName} {userData.lastName}</span><br></br>
                </div>
              </div>
            }
          </button>
          <ul className="dropdown-menu text-center">
            <li className='dropdown-item-edit'>
              <Link to={`/profile/${userData.userId}`} className='link'>
                اطلاعات کاربری
              </Link>
            </li>
            <li><hr className="dropdown-divider" /></li>
            <li className="dropdown-item-signout" onClick={() => { methods.logout() }}>
              <Link to="/login" className='link'>
                خروج
                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15.24 22.27H15.11C10.67 22.27 8.53002 20.52 8.16002 16.6C8.12002 16.19 8.42002 15.82 8.84002 15.78C9.24002 15.74 9.62002 16.05 9.66002 16.46C9.95002 19.6 11.43 20.77 15.12 20.77H15.25C19.32 20.77 20.76 19.33 20.76 15.26V8.73998C20.76 4.66998 19.32 3.22998 15.25 3.22998H15.12C11.41 3.22998 9.93002 4.41998 9.66002 7.61998C9.61002 8.02998 9.26002 8.33998 8.84002 8.29998C8.42002 8.26998 8.12001 7.89998 8.15001 7.48998C8.49001 3.50998 10.64 1.72998 15.11 1.72998H15.24C20.15 1.72998 22.25 3.82998 22.25 8.73998V15.26C22.25 20.17 20.15 22.27 15.24 22.27Z" fill="#292D32" />
                  <path d="M15.0001 12.75H3.62012C3.21012 12.75 2.87012 12.41 2.87012 12C2.87012 11.59 3.21012 11.25 3.62012 11.25H15.0001C15.4101 11.25 15.7501 11.59 15.7501 12C15.7501 12.41 15.4101 12.75 15.0001 12.75Z" fill="#292D32" />
                  <path d="M5.84994 16.1C5.65994 16.1 5.46994 16.03 5.31994 15.88L1.96994 12.53C1.67994 12.24 1.67994 11.76 1.96994 11.47L5.31994 8.11997C5.60994 7.82997 6.08994 7.82997 6.37994 8.11997C6.66994 8.40997 6.66994 8.88997 6.37994 9.17997L3.55994 12L6.37994 14.82C6.66994 15.11 6.66994 15.59 6.37994 15.88C6.23994 16.03 6.03994 16.1 5.84994 16.1Z" fill="#292D32" />
                </svg>
              </Link>
            </li>
          </ul>
        </div>
      </header>
    )
  };

  return (
    <>
      {renderHeader()}
    </>
  );
};

export default WaiterHeader;